import {reportBug} from '@packages/utilities/reporter';
import {Plugins, Component} from '@packages/systems/wfdl';
import {dataTypesFromComponents} from '@packages/systems/core/render';
import {rteHtmlToJsonNodes, rteJsonNodesToHtml} from './JsonDomUtils';

/**
 * Just a wrapper around jsonDomUtils with front-end error reporting
 */
export const frontEndRteHtmlToJsonNodes = (html: any, opts: any): any => {
  return rteHtmlToJsonNodes(html, {
    ...opts,
    addType: true,
    // @ts-expect-error - TS7006 - Parameter 'err' implicitly has an 'any' type.
    onError: (err) => {
      // Please see https://github.com/webflow/webflow/pull/39900
      // eslint-disable-next-line webflow/better-bug-reporting
      reportBug('HtmlToAbstractJsonParseError', 'HTML -> JSON parsing error', {
        html,
        error: err.name,
        message: err.message,
      });
    },
    supportHtmlEmbeds: true,
  });
};

/**
 * Converts an array of jsonNodes to an HTML string.
 * NOTE: This should only be used in the context of legacy RTE 1.x compatable HTML for editing.
 * @param  {Object[]} jsonNodes         An array of node JSON objects as stored on the server.
 * @param  {Object[]} styleBlockState   State from StyleBlockStore.
 * @param  {String}   conversionType    Enum to customize conversion output
 * @return {String}                     An HTML representation of those nodes.
 */
export const legacyRteJsonNodesToHtml = (
  plugins: Plugins.PluginsType,
  components: Component.ComponentMap,
  jsonNodes: any,
  styleBlockState: any,
  conversionType: any
): string => {
  const classNameMap = styleBlockState ? styleBlockState.getClassNameMap() : {};

  try {
    const dataTypes = dataTypesFromComponents(plugins, components);
    return rteJsonNodesToHtml(
      plugins,
      dataTypes,
      jsonNodes,
      classNameMap,
      conversionType
    );
  } catch (err: any) {
    // Please see https://github.com/webflow/webflow/pull/39900
    // eslint-disable-next-line webflow/better-bug-reporting
    reportBug('JsonNodesToHtmlError', 'JSON -> HTML conversion error', {
      jsonNodes,
      classNameMap,
      error: err.name,
      message: err.message,
    });
  }

  return '';
};
